import { LayoutHOC } from 'base/ui/layout/layout';
import { createAddTestTarget } from './addTestTarget';

export const createAddTestTargetPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createAddTestTarget());
};
